export const EMPTY_MESSAGE_ID = 0
export const LIST_CONVERSATION = 'list'
